export const ONBOARDING_STATUS_COMPLETED = "COMPLETED" as const;
